import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Global network-failure handler: HTTP errors are toasted locally by each page;
// network-level failures (no response) get a user-friendly toast with retry here.
api.interceptors.response.use(null, (error) => {
  const cfg = error.config || {};
  const url = cfg.url || "";
  const silent = ["/auth/", "/notifications", "/copilot/"].some((p) => url.includes(p));
  if (!error.response && !silent) {
    import("./toast").then(({ toastErr }) =>
      toastErr("Network error — check your connection", () => api.request(cfg)));
  }
  return Promise.reject(error);
});

export function fmtErr(e) {
  const status = e?.response?.status;
  const data = e?.response?.data;
  if (data && typeof data === "object") {
    const detail = data.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
      return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    if (detail && typeof detail.message === "string") return detail.message;
    if (detail != null) return String(detail);
    if (typeof data.message === "string") return data.message;
  }
  // gateway/proxy error pages (Cloudflare 502/503/520 HTML during a hot reload, etc.)
  if (typeof data === "string" || [502, 503, 504, 520, 521, 522, 523, 524].includes(status))
    return "The service is temporarily unavailable (it may be restarting) — please retry in a few seconds.";
  return e?.message || "Something went wrong. Please try again.";
}
